import {formatWithTickSize} from 'utils/format'
import {TICK_SIZE} from 'constants'

export function getTickerDisplay (ticker = {}, symbol) {
  const {
    lastPrice: close = 0,
    openPrice: open = 0,
    quoteVolume,
    tickSize = TICK_SIZE,
    markPrice = {},
    ...others
  } = ticker

  const diffPrice = close - open
  const prefix = diffPrice > 0 ? '+' : ''
  let difference = ((diffPrice / open || 0) * 100).toFixed(2)
  difference = `${prefix}${difference}`

  let obj = {
    symbol,
    openPrice: open,
    lastPrice: formatWithTickSize(close, tickSize),
    quoteVolume: Number(quoteVolume),
    quoteVolumeDisplay: quoteVolume,
    difference,
    diffPrice,
    ...others
  }

  if (typeof markPrice === 'number' || typeof markPrice === 'string') {
    obj.markPrice = markPrice
  } else {
    obj = Object.assign({}, obj, markPrice)
  }

  return obj
}
